module.exports = __webpack_public_path__ + "img/t_0038.ab8e60ff.gif";